import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { LayoutDashboard, LineChart, Gauge, Shield } from "lucide-react";

export const Route = createFileRoute("/_authenticated/dashboard/admin")({
  component: AdminLayout,
});

const tabs: { to: string; label: string; icon: typeof Gauge; exact?: boolean }[] = [
  { to: "/dashboard/admin", label: "Overview", icon: LayoutDashboard, exact: true },
  { to: "/dashboard/admin/reports", label: "Reports", icon: LineChart },
  { to: "/dashboard/admin/speed", label: "Speed", icon: Gauge },
  { to: "/dashboard/admin/security", label: "Security", icon: Shield },
];

function AdminLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="space-y-6">
      <div className="border-b border-border -mx-4 md:-mx-6 px-4 md:px-6 bg-card/30 sticky top-0 z-10 backdrop-blur">
        <nav className="flex gap-1 overflow-x-auto py-2">
          {tabs.map((t) => {
            const active = t.exact ? pathname === t.to : pathname.startsWith(t.to);
            return (
              <Link
                key={t.to}
                to={t.to as any}
                className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                  active
                    ? "bg-brand/15 text-brand"
                    : "text-muted-foreground hover:text-foreground hover:bg-background"
                }`}
              >
                <t.icon size={14} />
                {t.label}
              </Link>
            );
          })}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
